import React from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button, OverlayTrigger } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import { FaRegFolderOpen } from "react-icons/fa6";
import { BiSolidDuplicate } from "react-icons/bi";
import { RiLayout4Fill } from "react-icons/ri";
import { usdCurrencyFormat } from './numberFormats';

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'10%'}}>Fast Quote Number</th>
        <th style={{width:'5%'}}>Version Number</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Created By</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Created At</th>
        <th className='d-none d-sm-table-cell' style={{width:'5%'}}>Base Cabinets</th>
        <th className='d-none d-sm-table-cell' style={{width:'5%'}}>Tall Cabinets</th>
        <th className='d-none d-sm-table-cell' style={{width:'5%'}}>Wall Cabinets</th>        
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>TOTAL QUOTED AMOUNT</th>        
        <th style={{width:'5%'}}>{props.mode==0?'Open Quote':''}</th>
        <th style={{width:'5%'}}>{props.mode==0?'Open Design':''}</th>
        <th style={{width:'5%'}}>Duplicate</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  if (props.FastQuotingCabinetVersionsObj) {
    const rows = props.FastQuotingCabinetVersionsObj.map((row, index) => { 
      return (      
        <tr key={index}>   
          <td>
            {row.fastquotingcabinet.fastquotingcabinetnumber}
          </td>    
          <td>      
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderEditTooltip}>
              <Link
                versionnumber = {row.versionnumber}
                to={`/view-cabinet-fast-quote-versions/${row.id}`}
              >              
                {String(row.versionnumber).padStart(5, '0')}
              </Link>  
            </OverlayTrigger>         
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row.user?row.user.userlastname + ", " + row.user.userfirstname:null}
          </td>   
          <td className='d-none d-sm-table-cell'>  
            {new Date(row.createdAt).toUTCString()}
          </td>            
          <td className='d-none d-sm-table-cell'> 
            {row.baseCabinets}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row.tallCabinets}
          </td>  
          <td className='d-none d-sm-table-cell'>  
            {row.wallCabinets}
          </td>                  
          <td className='d-none d-sm-table-cell' style={{textAlign:'right'}}>  
            {usdCurrencyFormat(row.calculation[0].totalquoteversionwithunknownfactor)}
          </td> 
          <td align='center'>  
            {(props.mode==0) &&
              <Button variant='success'><Link to = {`/view-cabinet-fast-quoting/${row.id}`}><FaRegFolderOpen color='white'/></Link></Button>          
            }
            {(props.mode==1) &&
              <Button onClick={() => {
                console.log(row);
                props.onSelected(row.id,row.baseCabinets,row.tallCabinets,row.wallCabinets);
                props.handleClose();
              }} variant='success' value={row.id}>Select</Button>
            } 
          </td >   
          <td>
            {(row.kitchenfastquote) && (row.kitchenfastquote[0]) &&
              <Button variant='success'>
                <Link
                  to={`/edit-kitchen-fast-quote/${row.kitchenfastquote[0].id}`}
                    //search: "?sort=name",
                    //hash: "#the-hash",
                    
                    state= {{
                      zeroIndexWall: row.kitchenfastquote[0].zeroIndexWall,
                      walls: row.kitchenfastquote[0].walls,
                      specialnotes: row.kitchenfastquote[0].specialnotes,
                      fastquotingcabinetId: row.fastquotingcabinetId,                        
                      fastquotingcabinetversionId: row.calculation[0].fastquotingcabinetversionId
                    }}
                  
                >
                  <RiLayout4Fill color='white'/>                    
                </Link>                          
              </Button>



            }
          </td>
          <td align='center'>  
            <Button variant='success' onClick={() => {
              console.log(row);
              if (row.kitchenfastquote?.length > 0) {
                alert("Cannot duplicate version associated to a Kitchen Design. Please, open the Kitchen Design and save it as a new version from there.");
                return;
              }
              props.duplicateVersion(row.fastquotingcabinetId, row.id);
            }}>
              <BiSolidDuplicate />
            </Button>
            
          </td>         
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to view and create quote versions.
  </Tooltip>
);



const FastQuoteCabinetVersionsList = (props) => {        
  
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline", marginLeft:"13px",width:"99%"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode} />
            <TableBody 
              handleClose={props.handleClose} 
              onSelected={props.onSelected} 
              mode={props.mode} 
              FastQuotingCabinetVersionsObj={props.listOfFastQuotingCabinetVersions} 
              duplicateVersion={props.duplicateVersion}
            />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default FastQuoteCabinetVersionsList;